<template>
  <gj-modal
    :visible.sync="modalVisible"
    :destroyOnClose="true"
    :footer="false"
    size="normal"
    :loading="importHandleLoading"
    :loading-text="importHandleLoadingText"
  >
    <template #header>
      <span>导入运营状态</span>
    </template>
    <template #content>
      <div>
        <gj-upload
          class="upload-btn"
          :template-url="'/operation/listing/exportOperationStatusTemplate'"
          container-type="listingOperation"
          @uploadAfter="importOperationState"
        >
          <template #tip>
            <span>只能上传xls/xlsx文件</span>
          </template>
        </gj-upload>
        <gj-import-alert
          :rules="[
            '模板中的表头不可更改，不能删除',
            'MSKU和运营状态对应关系多条时，以最后一条记录为准',
            '导入已有运营状态的MSKU，会更新MSKU原来的运营状态',
            '导入MSKU的运营状态为空，会清空MSKU的运营状态',
            '文件大小不可超过20M',
          ]"
        >
        </gj-import-alert>
      </div>
    </template>
  </gj-modal>
</template>

<script>
import { modalMixIn, uploadMixin } from '../../../../../minxins';
import { importOperationState } from '../../../../../api/sale';

export default {
  name: 'app-import-operation-modal',
  mixins: [modalMixIn, uploadMixin],
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    importOperationState(attId, data, uploadCb) {
      this.importHandleLoading = true;
      importOperationState(attId)
        .then((res) => {
          this.$gjImportHandle(res, uploadCb);
        })
        .catch(() => {
          uploadCb('error');
        })
        .complete(() => (this.importHandleLoading = false));
    },
  },
};
</script>

<style scoped>
.checkbox {
  margin: 8px 0;
}
.upload-btn {
  margin-bottom: 16px;
}
/*/deep/ .gj-modal--custom .el-dialog {*/
/*  width: 700px !important;*/
/*}*/
</style>
